import React, { Component, useState } from "react";
import {
  Heart,
  Coffee,
  Utensils,
  Flame,
  Tv,
  Snowflake,
  Sparkles,
  Moon,
  Music,
  CreditCard,
  QrCode,
  Zap,
  Wind,
  Armchair,
  Plane,
  Baby,
  Clapperboard,
  Gem,
} from "lucide-react";
import "./style.css";

class Gift extends Component {
  render() {
    return (
      <div className="gift-area">
        <div className="container">
          <div className="col-12">
            <div className="section-title text-center">
              <h2>Hộp mừng cưới</h2>
              <p>
                Thật vui vì được gặp và đón tiếp các bạn trong một dịp đặc biệt
                như đám cưới của chúng mình.
              </p>
            </div>
          </div>
        </div>

        {/* Gift Wishlist Section với Marquee Scroll */}
        <GiftWishlist />
      </div>
    );
  }
}

// Gift Wishlist Component với Marquee Scroll
const GiftWishlist = () => {
  const [gifts] = useState([
    {
      id: 1,
      name: "Nồi Cơm Thần Kỳ",
      description: "Cơm dẻo canh ngọt, ấm lòng người thương",
      price: "200.000đ",
      icon: <Utensils strokeWidth={1.5} size={24} />,
      qrImage: "https://lh3.googleusercontent.com/d/1Pc7hzXCv40ZYVa-2NPfXQTUHJ_4djR23",
    },
    {
      id: 2,
      name: "Bếp Ga Giữ Lửa",
      description: "Hâm nóng tình cảm mỗi ngày",
      price: "350.000đ",
      icon: <Flame strokeWidth={1.5} size={24} />,
      qrImage: "https://lh3.googleusercontent.com/d/1LG3DAM0jXsn4Kt42Azyl0IdeYvBxNKla",
    },
    {
      id: 3,
      name: "Tủ Lạnh Đầy Ắp",
      description: "Kho báu đồ ăn vặt bất tận",
      price: "1.000.000đ",
      icon: <Snowflake strokeWidth={1.5} size={24} />,
      qrImage: "https://lh3.googleusercontent.com/d/1vUmNG7Y7vROFRosE-n28H2mLWZrKhTRs",
    },
    {
      id: 4,
      name: "Máy Xay Sinh Tố",
      description: "Xay tan mọi ưu phiền",
      price: "300.000đ",
      icon: <Coffee strokeWidth={1.5} size={24} />,
      qrImage: "https://lh3.googleusercontent.com/d/1E0BaN9JCFvQjqS7_eZDrw8Zr_h07HIIi",
    },
    {
      id: 5,
      name: "TV Cày Phim",
      description: "Rạp chiếu phim tại gia ấm cúng",
      price: "1.500.000đ",
      icon: <Tv strokeWidth={1.5} size={24} />,
      qrImage: "https://lh3.googleusercontent.com/d/1xyoIsGXYPfODVfLAj5uovW2LvjVzdy1R",
    },
    {
      id: 6,
      name: "Bộ Chăn Ga Mới",
      description: "Giấc ngủ êm đềm, mơ về tương lai",
      price: "700.000đ",
      icon: <Moon strokeWidth={1.5} size={24} />,
      qrImage: "https://lh3.googleusercontent.com/d/114naRsSNt2d3Mp6GyyAiVjdCYwXyQ493",
    },
    {
      id: 7,
      name: "Máy Hút Bụi",
      description: "Nhà sạch thì mát, bát sạch ngon cơm",
      price: "900.000đ",
      icon: <Sparkles strokeWidth={1.5} size={24} />,
      qrImage: "https://lh3.googleusercontent.com/d/1tZfMlHFFNDpqlti8IPDgQV1pdj3-uk0L",
    },
    {
      id: 8,
      name: "Loa Chill Chill",
      description: "Giai điệu tình yêu du dương",
      price: "500.000đ",
      icon: <Music strokeWidth={1.5} size={24} />,
      qrImage: "https://lh3.googleusercontent.com/d/1saQ7sju93TgsKj2GVSMI36_mdfoRMmIP",
    },
    {
      id: 9,
      name: "Máy Rửa Bát",
      description: "Bảo vệ đôi tay ngọc ngà của vợ",
      price: "2.500.000đ",
      icon: <Zap strokeWidth={1.5} size={24} />,
      qrImage: "https://lh3.googleusercontent.com/d/1QTg3AfKNxs8fuqUbl9ByTyWq6TTgdB8W",
    },
    {
      id: 10,
      name: "Robot Hút Bụi",
      description: "Sen công nghệ thay chồng làm việc",
      price: "900.000đ",
      icon: <BotIcon />,
      qrImage: "https://lh3.googleusercontent.com/d/1wcx6jiDgLp2lZfshGvO6HqtYFGhCyxye",
    },
    {
      id: 11,
      name: "Máy Lọc Không Khí",
      description: "Hít thở không khí drama-free",
      price: "1.800.000đ",
      icon: <Wind strokeWidth={1.5} size={24} />,
      qrImage: "https://lh3.googleusercontent.com/d/1f32DEHGBzNKVZVXV1rAnleXDRGV_MwIQ",
    },
    {
      id: 12,
      name: "Sofa Êm Ái",
      description: "Nơi chồng ngủ khi vợ giận",
      price: "2.000.000đ",
      icon: <Armchair strokeWidth={1.5} size={24} />,
      qrImage: "https://lh3.googleusercontent.com/d/1Iok_lACsv4H0WFbqbaJTqPzNw32HRbuU",
    },
    {
      id: 13,
      name: "Vali Du Lịch",
      description: "Đưa nhau đi trốn thế gian",
      price: "1.000.000đ",
      icon: <Plane strokeWidth={1.5} size={24} />,
      qrImage: "https://lh3.googleusercontent.com/d/1Xy38ozhG2LphBVfbL9-IUhs9tJ3ytMb7",
    },
    {
      id: 14,
      name: "Quỹ Tã Bỉm",
      description: "Đầu tư cho thế hệ tương lai",
      price: "300.000đ",
      icon: <Baby strokeWidth={1.5} size={24} />,
      qrImage: "https://lh3.googleusercontent.com/d/1rOwg-PA_UIpjQfsg3kFtDd0k6Udf8ETe",
    },
    {
      id: 15,
      name: "Gói Netflix 1 Năm",
      description: "Chill mỗi tối không lo quảng cáo",
      price: "400.000đ",
      icon: <Clapperboard strokeWidth={1.5} size={24} />,
      qrImage: "https://lh3.googleusercontent.com/d/1rOwg-PA_UIpjQfsg3kFtDd0k6Udf8ETe",
    },
    {
      id: 16,
      name: "Voucher Spa",
      description: "Để vợ luôn xinh đẹp rạng ngời",
      price: "1.000.000đ",
      icon: <Gem strokeWidth={1.5} size={24} />,
      qrImage: "https://lh3.googleusercontent.com/d/1vUmNG7Y7vROFRosE-n28H2mLWZrKhTRs",
    },
    {
      id: 17,
      name: "Quỹ Trăng Mật",
      description: "Góp gạch xây lâu đài tình ái",
      price: "Tùy tâm",
      icon: <CreditCard strokeWidth={1.5} size={24} />,
      qrImage: "https://lh3.googleusercontent.com/d/1yEitWa9xW8aizN6xyH-SRMV7-XgFjnCQ",
    },
  ]);

  const [selectedGift, setSelectedGift] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleSelectGift = (gift) => {
    setSelectedGift(gift);
    setShowModal(true);
  };

  // Helper component for Bot icon
  function BotIcon(props) {
    return (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 8V4H8" />
        <rect width="16" height="12" x="4" y="8" rx="2" />
        <path d="M2 14h2" />
        <path d="M20 14h2" />
        <path d="M15 13v2" />
        <path d="M9 13v2" />
      </svg>
    );
  }

  // Gift Card Component
  const GiftCard = ({ gift }) => (
    <div onClick={() => handleSelectGift(gift)} className="gift-card-item">
      {/* Price badge */}
      <div className="gift-card-price">{gift.price}</div>

      {/* Content */}
      <div className="gift-card-content">
        {/* Icon */}
        <div className="gift-card-icon">{gift.icon}</div>

        {/* Text */}
        <div className="gift-card-text">
          <h3 className="gift-card-title">{gift.name}</h3>
          <p className="gift-card-description">{gift.description}</p>
        </div>
      </div>

      {/* Button */}
      <button className="gift-card-button">
        <QrCode size={14} />
        Tặng món này
      </button>
    </div>
  );

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@400;600;700&family=Playfair+Display:ital,wght@0,600;1,600&display=swap');
        
        .gift-wishlist-section {
          padding: 40px 0 40px;
          position: relative;
          overflow: hidden;
        }

        /* Marquee Container */
        .gift-marquee-wrapper {
          position: relative;
          width: 100%;
          padding: 24px 0 40px 0;
        }

        .gift-marquee-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 15px;
          position: relative;
        }
        
        .gift-marquee-track-wrapper {
          overflow: hidden;
          padding: 8px 0;
        }

        .gift-marquee-gradient-left,
        .gift-marquee-gradient-right {
          position: absolute;
          top: 0;
          bottom: 0;
          width: 80px;
          z-index: 10;
          pointer-events: none;
        }

        .gift-marquee-gradient-left {
          left: 0;
          background: linear-gradient(to right, #f4f9f8, transparent);
        }

        .gift-marquee-gradient-right {
          right: 0;
          background: linear-gradient(to left, #f4f9f8, transparent);
        }

        @media (min-width: 768px) {
          .gift-marquee-gradient-left,
          .gift-marquee-gradient-right {
            width: 120px;
          }
        }

        /* Marquee Animation */
        @keyframes giftMarquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        .gift-marquee-track {
          display: flex;
          animation: giftMarquee 80s linear infinite;
          width: max-content;
          padding: 0;
          position: relative;
        }

        .gift-marquee-track:hover {
          animation-play-state: paused;
        }

        /* Gift Card */
        .gift-card-item {
          flex: none;
          width: 280px;
          margin: 0 12px;
          position: relative;
          background: white;
          border-radius: 12px;
          padding: 16px;
          transition: all 0.3s ease;
          cursor: pointer;
          border: 1px solid transparent;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          box-sizing: border-box;
        }
        
        .gift-card-item:first-child {
          margin-left: 0;
        }
        
        .gift-card-item:last-child {
          margin-right: 0;
        }

        .gift-card-item:hover {
          transform: translateY(-5px) scale(1.03);
          border-color: rgba(100, 158, 147, 0.3);
          box-shadow: 0 12px 32px rgba(100, 158, 147, 0.25);
          z-index: 5;
        }

        .gift-card-price {
          position: absolute;
          top: 0;
          right: 0;
          z-index: 10;
          background: #649e93;
          color: white;
          font-size: 10px;
          font-weight: bold;
          padding: 4px 8px;
          border-radius: 0 12px 0 12px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        .gift-card-content {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          margin-bottom: 12px;
          margin-top: 4px;
        }

        .gift-card-icon {
          flex-shrink: 0;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(100, 158, 147, 0.1);
          color: #649e93;
          transition: all 0.3s ease;
        }

        .gift-card-item:hover .gift-card-icon {
          background: #649e93;
          color: white;
        }

        .gift-card-text {
          flex: 1;
          min-width: 0;
          padding-top: 2px;
          text-align: left;
        }

        .gift-card-title {
          font-family: 'Playfair Display', serif;
          font-size: 16px;
          font-weight: bold;
          color: #334155;
          margin: 0 0 4px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          transition: color 0.3s ease;
        }

        .gift-card-item:hover .gift-card-title {
          color: #649e93;
        }

        .gift-card-description {
          font-family: 'Quicksand', sans-serif;
          font-size: 12px;
          color: #64748b;
          margin: 0;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .gift-card-button {
          width: 100%;
          padding: 8px;
          border: 1px solid #649e93;
          color: #649e93;
          font-family: 'Quicksand', sans-serif;
          font-weight: 600;
          border-radius: 8px;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          font-size: 11px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          background: white;
        }

        .gift-card-button:hover {
          background: #649e93;
          color: white;
        }

        .gift-wishlist-footer {
          margin-top: 24px;
          text-align: center;
          font-family: 'Quicksand', sans-serif;
          color: #94a3b8;
          font-size: 12px;
        }

        .gift-wishlist-footer p {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          margin: 0;
        }

        /* Modal */
        .gift-modal-overlay {
          position: fixed;
          inset: 0;
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 16px;
          background: rgba(44, 62, 80, 0.4);
          backdrop-filter: blur(4px);
          transition: all 0.3s ease;
        }

        .gift-modal-content {
          background: white;
          border-radius: 16px;
          padding: 24px;
          max-width: 400px;
          width: 100%;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
          position: relative;
          font-family: 'Quicksand', sans-serif;
          animation: giftModalFadeIn 0.3s ease-out;
        }

        @keyframes giftModalFadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .gift-modal-close {
          position: absolute;
          top: 12px;
          right: 12px;
          background: none;
          border: none;
          font-size: 24px;
          color: #cbd5e1;
          cursor: pointer;
          transition: color 0.2s ease;
          padding: 0;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .gift-modal-close:hover {
          color: #64748b;
        }

        .gift-modal-header {
          text-align: center;
          margin-bottom: 24px;
        }

        .gift-modal-icon-wrapper {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 56px;
          height: 56px;
          background: rgba(100, 158, 147, 0.1);
          border-radius: 50%;
          margin-bottom: 12px;
          color: #649e93;
        }

        .gift-modal-title {
          font-family: 'Playfair Display', serif;
          font-size: 20px;
          font-weight: 600;
          color: #334155;
          margin: 0 0 8px 0;
        }

        .gift-modal-price {
          display: inline-block;
          background: #f1f5f9;
          color: #475569;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 14px;
          font-weight: bold;
        }

        .gift-modal-qr {
          background: white;
          padding: 8px;
          border-radius: 12px;
          border: 2px solid rgba(100, 158, 147, 0.2);
          box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
          margin-bottom: 16px;
          display: flex;
          justify-content: center;
        }

        .gift-modal-qr img {
          width: 192px;
          height: 192px;
          object-fit: contain;
          border-radius: 8px;
          mix-blend-mode: multiply;
        }

        .gift-modal-note {
          font-size: 11px;
          color: #94a3b8;
          text-align: center;
          font-style: italic;
          padding: 0 16px;
          line-height: 1.5;
        }

        @media (max-width: 768px) {
          .gift-card-item {
            width: 240px;
          }
        }
      `}</style>

      <div className="gift-wishlist-section">
        {/* Marquee Scroll Area */}
        <div className="gift-marquee-wrapper">
          <div className="gift-marquee-container">
            <div className="gift-marquee-gradient-left"></div>
            <div className="gift-marquee-gradient-right"></div>

            <div className="gift-marquee-track-wrapper">
              <div className="gift-marquee-track">
                {/* Render gifts twice for seamless loop */}
                {gifts.map((gift) => (
                  <GiftCard key={`original-${gift.id}`} gift={gift} />
                ))}
                {gifts.map((gift) => (
                  <GiftCard key={`duplicate-${gift.id}`} gift={gift} />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="gift-wishlist-footer">
          <p>Góp Gạo Thổi Cơm Chung • Mỗi món quà là một niềm vui</p>
        </div>
      </div>

      {/* Modal */}
      {showModal && selectedGift && (
        <div className="gift-modal-overlay" onClick={() => setShowModal(false)}>
          <div
            className="gift-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="gift-modal-close"
              onClick={() => setShowModal(false)}
            >
              ✕
            </button>

            <div className="gift-modal-header">
              <div className="gift-modal-icon-wrapper">
                {React.cloneElement(selectedGift.icon, { size: 32 })}
              </div>
              <h2 className="gift-modal-title">{selectedGift.name}</h2>
              <div className="gift-modal-price">
                Giá trị: {selectedGift.price}
              </div>
            </div>

            <div className="gift-modal-qr">
              <img
                src={selectedGift.qrImage}
                alt="QR Code"
              />
            </div>

            <p className="gift-modal-note">
              Cảm ơn bạn đã ghé thăm và dành tặng món quà ý nghĩa này cho chúng
              mình!
              <br />
              (Mong bạn ghi tên trong nội dung chuyển khoản để chúng mình biết
              ạ)
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default Gift;
